<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 83 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2882_16336)">
      <path
        d="M1 35.5702C1 29.8878 5.6001 25.2812 11.2746 25.2812H67.3774C73.0519 25.2812 77.652 29.8878 77.652 35.5702C77.652 41.2527 73.0519 45.8592 67.3774 45.8592H11.2746C5.6001 45.8592 1 41.2527 1 35.5702Z"
        fill="#004AAB"
      />
      <path
        d="M8.82812 35.5699C8.82812 34.217 9.9234 33.1201 11.2745 33.1201H75.2055C76.5565 33.1201 77.6518 34.217 77.6518 35.5699C77.6518 36.9228 76.5565 38.0196 75.2055 38.0196H11.2745C9.9234 38.0196 8.82812 36.9228 8.82812 35.5699Z"
        fill="#1C1363"
      />
      <path
        d="M77.652 35.3353C77.652 40.747 73.2711 45.1344 67.8666 45.1344H10.1982C5.18103 45.1344 1 40.9296 1 35.3232V94.1889C1 99.795 5.18103 104 10.1982 104H67.8666C73.2711 104 77.652 99.6127 77.652 94.2007V85.7794V80.7339V73.726V62.2333V35.3353Z"
        fill="#80B7FF"
      />
      <path
        d="M77.6523 52.7178C80.221 52.7178 82.2188 55.0143 82.2188 57.6173C82.2188 60.3734 80.221 62.5168 77.6523 62.5168"
        fill="#1C1363"
      />
      <path
        d="M44.3828 74.7233C44.3828 67.7543 50.0244 62.1048 56.9838 62.1048H77.7352C80.2576 62.1048 82.2195 60.1417 82.2195 57.6182V82.1543V82.4345C82.2195 84.9584 80.1177 87.3419 77.7352 87.3419H56.9838C50.0244 87.3419 44.3828 81.6924 44.3828 74.7233Z"
        fill="#BEDAFF"
      />
      <path
        d="M56.7755 80.4825C59.838 80.4825 62.3205 77.9965 62.3205 74.9297C62.3205 71.863 59.838 69.377 56.7755 69.377C53.713 69.377 51.2305 71.863 51.2305 74.9297C51.2305 77.9965 53.713 80.4825 56.7755 80.4825Z"
        fill="#1C1363"
      />
      <mask
        id="mask0_2882_16336"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="15"
        y="-1"
        width="49"
        height="39"
      >
        <path d="M63.5875 -1H15.0352V38H63.5875V-1Z" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2882_16336)">
        <path
          d="M39.3503 48.1552C52.585 48.1552 63.3139 37.4114 63.3139 24.1582C63.3139 10.905 52.585 0.161133 39.3503 0.161133C26.1156 0.161133 15.3867 10.905 15.3867 24.1582C15.3867 37.4114 26.1156 48.1552 39.3503 48.1552Z"
          fill="#006EFF"
        />
        <path
          d="M39.3494 44.0629C50.3271 44.0629 59.2262 35.1514 59.2262 24.1584C59.2262 13.1655 50.3271 4.25391 39.3494 4.25391C28.3718 4.25391 19.4727 13.1655 19.4727 24.1584C19.4727 35.1514 28.3718 44.0629 39.3494 44.0629Z"
          fill="#388EFF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50.3106 31.7624L46.5976 24.9443H33.6684L39.3573 14.534L44.2506 23.513H45.8155L39.3573 11.6719L31.3213 26.3752H45.8155L47.9637 30.3315H30.7378L32.1036 27.8202H30.5389L28.3906 31.7624H50.3106Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M39.3526 17.4104C37.2574 21.2406 35.1622 25.0567 33.0802 28.887H34.645L36.0109 26.3756H42.6809L44.047 28.887H45.6119C43.5298 25.0567 41.4344 21.2406 39.3526 17.4104ZM41.8988 24.9444H36.7933L39.3526 20.2726L41.8988 24.9444Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2882_16336">
        <rect width="83" height="105" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 83 },
    height: { type: [Number, String], default: 105 },
    color: { type: String, default: "#D3D4DE" },
  },
};
</script>
